import { render, staticRenderFns } from "./vipRenew.vue?vue&type=template&id=cd63b93c&scoped=true&"
import script from "./vipRenew.vue?vue&type=script&lang=ts&"
export * from "./vipRenew.vue?vue&type=script&lang=ts&"
import style0 from "./vipRenew.vue?vue&type=style&index=0&id=cd63b93c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd63b93c",
  null
  
)

export default component.exports